import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  return (
    <Link to={`/product/${product.id}`} data-testid={`product-card-${product.id}`}>
      <div className="product-card group bg-white rounded-xl overflow-hidden hover-lift professional-shadow border border-gray-100">
        <div className="relative overflow-hidden bg-gray-50 aspect-square">
          <img
            src={product.images[0]}
            alt={product.name}
            className="product-card-image w-full h-full object-cover"
            data-testid="product-card-image"
          />
          {product.featured && (
            <div className="absolute top-4 right-4 bg-[#14B8A6] text-white px-4 py-2 text-xs font-semibold rounded-full shadow-lg" data-testid="featured-badge">
              FEATURED
            </div>
          )}
        </div>
        <div className="p-6 space-y-2">
          <p className="text-sm text-[#14B8A6] uppercase tracking-wider font-semibold" data-testid="product-brand">
            {product.brand}
          </p>
          <h3 className="text-xl font-heading font-semibold text-gray-900 group-hover:text-[#14B8A6] transition-colors" data-testid="product-name">
            {product.name}
          </h3>
          <p className="text-sm text-gray-600 line-clamp-2">
            Premium quality footwear - Contact us for pricing
          </p>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;